import { pluralizeReviews } from '@lt/components/utils/pluralizeUtils';
import React from 'react';
import styled, { css } from 'styled-components';

type HotelCardRatingProps = {
  value: number;
  reviewsCount?: number;
};

const HotelRatingSquare = ({ value, reviewsCount }: HotelCardRatingProps) => {
  if (!value) return null;

  const formatReviews = (reviews: number): string => {
    try {
      const formattedValue = new Intl.NumberFormat('ru-RU').format(reviews);

      return formattedValue;
    } catch (err) {
      return `${reviews}`;
    }
  };

  return (
    <Rating value={value} reviewsCount={reviewsCount}>
      <RatingText>{value.toFixed(1)}</RatingText>
      {reviewsCount ? (
        <Reviews>
          {formatReviews(reviewsCount)} {pluralizeReviews(reviewsCount)}
        </Reviews>
      ) : null}
    </Rating>
  );
};

const getRatingStyle = (value: number) => {
  if (value >= 8.5) {
    return css`
      color: white;
      background: #00bc4b;
    `;
  }

  if (value >= 7) {
    return css`
      color: white;
      background: #6ac140;
    `;
  }

  return css`
    background: #888c93;
    color: white;
  `;
};

const Rating = styled.div<{ value: number; reviewsCount?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ reviewsCount }) =>
    reviewsCount ? `width: max-content;` : `width: 46px;`}

  height: 46px;

  font-weight: 700;
  font-size: 20px;

  ${({ value }) => getRatingStyle(value)};
  padding: 0 5px 0 5px;

  border-radius: 5px;
`;

const RatingText = styled.div`
  line-height: 24px;
`;

const Reviews = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
`;

export default HotelRatingSquare;
